/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});



// (function($) {
//   $(document).on('click', '.marker-item', function() {
//       e.preventDefault(); // Necessary if '.marker-item' is an <a> tag and you don't want it to open the post page itself.
//       var postid = $(this).attr('data-id');
//       var markers = FWP_MAP.get_post_markers(postid);

//       $.each( markers, function( key, value ) {
//           google.maps.event.trigger(value, 'spider_click');
//       });
//   });
// })(jQuery);
